import PropTypes from 'prop-types'
import React from 'react'
import TimeRangeField from '../../molecules/fields/TimeRangeField'

const AttentionHours = ({
  enabled,
  startName,
  endName,
  initialStartHour,
  initialEndHour,
  minRangeDifference,
  required
}) => {
  return (
    <div className="flex flex-col gap-4">
      <TimeRangeField
        startName={startName}
        startLabel="Hora de inicio de atención:"
        endName={endName}
        endLabel="Hora de fin de atención:"
        className="md:w-60"
        disabled={!enabled}
        initialStartHour={initialStartHour}
        initialEndHour={initialEndHour}
        minRangeDifference={minRangeDifference}
        required={required}
      />
    </div>
  )
}

export default AttentionHours

AttentionHours.propTypes = {
  enabled: PropTypes.bool,
  startName: PropTypes.string.isRequired,
  endName: PropTypes.string.isRequired,
  initialStartHour: PropTypes.string,
  initialEndHour: PropTypes.string,
  minRangeDifference: PropTypes.number,
  required: PropTypes.bool
}
